<template>
  <BaseButton
    icon
    variant="ghost"
    size="small"
    aria-label="back"
  >
    <ChevronLeft />
  </BaseButton>
</template>

<script setup>
import ChevronLeft from '@shared/assets/icon/ChevronLeft.vue'
import BaseButton from '@shared/components/BaseButton.vue'
</script>
